module.exports = require('./dist/index');


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-no-ssr/index.js
// module id = 826
// module chunks = 2